var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.316,
    height: 23.401,
    viewBox: "0 0 18.316 23.401",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3",
    "data-name": "Caminho 3",
    d: "M17.464,10.791a.62.62,0,0,0-.389-.635.842.842,0,0,0-.312-.057.811.811,0,0,0-.313.057.628.628,0,0,0-.4.635v8.955a.8.8,0,1,1-1.6,0v-7.78a.686.686,0,0,0-.389-.617,1.016,1.016,0,0,0-.3-.047,1.15,1.15,0,0,0-.322.047.713.713,0,0,0-.4.654V26a.787.787,0,0,1-.8.787.806.806,0,0,1-.759-.549L9.8,21.566c-.294-.834-1.678-.607-1.384.266l1.611,4.832.322.558,2.606,3.385a.794.794,0,1,1-1.261.965l-2.643-3.42-.057-.1-.379-.662a.482.482,0,0,1-.076-.172L6.916,22.343c-.966-2.881,3.374-4.132,4.388-1.308l.143.4V12a2.143,2.143,0,0,1,1.4-2.123,2.281,2.281,0,0,1,.909-.169,2.6,2.6,0,0,1,.872.15,2.091,2.091,0,0,1,1.223-1.184,2.361,2.361,0,0,1,.91-.179,2.328,2.328,0,0,1,.909.179,2.152,2.152,0,0,1,1.194,1.139,2.363,2.363,0,0,1,1.819,0,2.144,2.144,0,0,1,1.394,2.111v.617a2.242,2.242,0,0,1,.7-.1,2.443,2.443,0,0,1,.929.172,2.18,2.18,0,0,1,1.384,2.123V27.1a.458.458,0,0,1-.02.172l-1.014,4.008a.8.8,0,0,1-.966.6.817.817,0,0,1-.588-.987L23.481,27V14.734a.646.646,0,0,0-.388-.637.858.858,0,0,0-.313-.056.777.777,0,0,0-.312.056.633.633,0,0,0-.389.6v5.051a.806.806,0,0,1-.806.806.8.8,0,0,1-.786-.806V11.927a.651.651,0,0,0-.4-.644.854.854,0,0,0-.313-.057.865.865,0,0,0-.322.057.633.633,0,0,0-.389.617v7.846a.8.8,0,1,1-1.6,0Z",
    transform: "translate(-6.777 -8.498)",
    fill: "#7b8590"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHand);
export default __webpack_public_path__ + "static/media/hand.417b5a7ebbde4880f10456ab9838e2b3.svg";
export { ForwardRef as ReactComponent };